import { WebsiteBlockTextAndMediaImageDisplayItem } from '../api/WebsiteBlockTextAndMediaImageDisplayItem';
import { WebsiteBlockTextAndMediaImageInputItem } from '../api/WebsiteBlockTextAndMediaImageInputItem';

declare module '../api/WebsiteBlockTextAndMediaImageDisplayItem' {
    namespace WebsiteBlockTextAndMediaImageDisplayItem {
        let ConvertToInputItem: typeof convertToInputItem;
    }
}

WebsiteBlockTextAndMediaImageDisplayItem.ConvertToInputItem = convertToInputItem;

function convertToInputItem(displayItem: WebsiteBlockTextAndMediaImageDisplayItem): WebsiteBlockTextAndMediaImageInputItem {
    const result = new WebsiteBlockTextAndMediaImageInputItem({
        Header: displayItem.Header,
        Body: displayItem.Body,
        AltText: displayItem.AltText,
        Hyperlink: displayItem.Hyperlink,
        OpenInNewTab: displayItem.OpenInNewTab,
        OffsetXPercent: displayItem.OffsetXPercent,
        OffsetYPercent: displayItem.OffsetYPercent,
        ImageScale: displayItem.ImageScale,
    });

    if (displayItem.WebsiteMediaLibraryItemID?.startsWith('uid_')) {
        result.WebsiteMediaLibraryItemID = null;
        result.PlaceholderUrl = displayItem.Url;
    } else {
        result.WebsiteMediaLibraryItemID = displayItem.WebsiteMediaLibraryItemID;
    }

    return result;
}
